import { EnvironmentProviders, inject, InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '#environments';
import { HttpWorkflowEngineGateway } from './http-workflow-engine.gateway';
import { WORKFLOW_ENGINE_GATEWAY, WorkflowEngineGateway } from './workflow-engine-gateway';

export interface WorkflowEngineConfiguration {
  engineApiUrl?: string;
  engineScope?: string;
}

export const WORKFLOW_ENGINE_CONFIGURATION = new InjectionToken<WorkflowEngineConfiguration>(
  'WORKFLOW_ENGINE_CONFIGURATION',
  { providedIn: 'root', factory: () => environment },
);

/** True when the deployed engine URL and delegated scope are configured. */
export function usesRealWorkflowEngine(configuration: WorkflowEngineConfiguration): boolean {
  return !!configuration.engineApiUrl && !!configuration.engineScope;
}

export function createWorkflowEngineGateway(
  http: HttpClient,
  configuration: WorkflowEngineConfiguration,
): WorkflowEngineGateway {
  return new HttpWorkflowEngineGateway(http, configuration.engineApiUrl ?? '', usesRealWorkflowEngine(configuration));
}

export function provideWorkflowEngineGateway(
  configuration: WorkflowEngineConfiguration = environment,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: WORKFLOW_ENGINE_GATEWAY,
      useFactory: () => createWorkflowEngineGateway(
        inject(HttpClient),
        configuration,
      ),
    },
  ]);
}